<div class="strategies-container">
  <div class="strategies-container__menu-bar">
    Strategies
    <div>
      <button
        class="strategies-container__button-close"
        (click)="updateStrategiesGridVis(false)"
      ></button>
    </div>
  </div>
  <div
    class="strategies-container__resize-container resize-able"
    appResizerHorizontal
    [minWidth]="190"
  >
    <div class="strategies-container__data">
      <clr-tabs>
        <clr-tab>
          <button clrTabLink>Saved</button>
          <ng-template [(clrIfActive)]="savedActive">
            <clr-tab-content>
              <div class="strategies-container__data-grid__container">
                <clr-datagrid
                  class="strategies-container__data-grid"
                  [(clrDgSingleSelected)]="selectedSaved"
                >
                  <clr-dg-column *ngFor="let column of savedColumns">
                    {{ column.displayName }}
                  </clr-dg-column>

                  <clr-dg-row
                    *clrDgItems="let savedStrat of savedStrategies$ | async"
                    [clrDgItem]="savedStrat"
                  >
                    <clr-dg-cell *ngFor="let column of savedColumns">
                      <ng-container *ngIf="column.dbName === 'name'">
                        {{ savedStrat[column.dbName] }}
                      </ng-container>
                      <ng-container *ngIf="column.dbName === 'timestamp'">
                        {{
                          savedStrat[column.dbName] | date: 'MMM d y h:mm:ss a'
                        }}
                      </ng-container>
                    </clr-dg-cell>
                  </clr-dg-row>
                  <clr-dg-footer>
                    <div
                      class="strategies-container__data-grid--footer"
                      *ngIf="savedStrategies$ | async as strategies"
                    >
                      {{
                        strategies?.length || 0
                          | i18nPlural
                            : {
                                '=0': 'No saved strategies',
                                '=1': 'One saved strategy',
                                other: '# saved strategies'
                              }
                      }}
                      <div class="footer-buttons">
                        <ng-container
                          *ngTemplateOutlet="strategyLoadButtonTmpl"
                        ></ng-container>
                        <ng-container
                          *ngTemplateOutlet="strategyDeleteButtonTmpl"
                        ></ng-container>
                      </div>
                    </div>
                  </clr-dg-footer>
                </clr-datagrid>
              </div>
            </clr-tab-content>
          </ng-template>
        </clr-tab>
        <clr-tab>
          <button clrTabLink>Shared</button>
          <ng-template [(clrIfActive)]="sentActive">
            <clr-tab-content>
              <div class="strategies-container__data-grid__container">
                <clr-datagrid
                  class="strategies-container__data-grid"
                  [(clrDgSingleSelected)]="selectedSent"
                >
                  <clr-dg-column *ngFor="let column of sentColumns">
                    {{ column.displayName }}
                  </clr-dg-column>

                  <clr-dg-row
                    *clrDgItems="let sharedStrat of sharedStrategies$ | async"
                    [clrDgItem]="sharedStrat"
                  >
                    <clr-dg-cell
                      *ngFor="let column of sentColumns"
                      [ngClass]="
                        column.dbName === 'message' ? 'center-col' : ''
                      "
                    >
                      <ng-container *ngIf="column.dbName === 'name'">
                        {{ sharedStrat[column.dbName] }}
                      </ng-container>
                      <ng-container *ngIf="column.dbName === 'shared'">
                        {{ getUserEmail(sharedStrat['userId']) }}
                      </ng-container>
                      <ng-container *ngIf="column.dbName === 'timestamp'">
                        {{
                          sharedStrat[column.dbName] | date: 'MMM d y h:mm:ss a'
                        }}
                      </ng-container>
                      <ng-container *ngIf="column.dbName === 'message'">
                        <a
                          *ngIf="sharedStrat[column.dbName]"
                          role="tooltip"
                          aria-haspopup="true"
                          class="tooltip tooltip-md tooltip-left"
                        >
                          <img src="assets/messages.svg" />
                          <span class="tooltip-content"
                            >{{ sharedStrat[column.dbName] }}
                          </span>
                        </a>
                      </ng-container>
                    </clr-dg-cell>
                  </clr-dg-row>
                  <clr-dg-footer>
                    <div
                      class="strategies-container__data-grid--footer"
                      *ngIf="sharedStrategies$ | async as strategies"
                    >
                      {{
                        strategies?.length || 0
                          | i18nPlural
                            : {
                                '=0': 'No shared strategies',
                                '=1': 'One shared strategy',
                                other: '# shared strategies'
                              }
                      }}
                      <div class="footer-buttons">
                        <ng-container
                          *ngTemplateOutlet="strategyLoadButtonTmpl"
                        ></ng-container>
                      </div>
                    </div>
                  </clr-dg-footer>
                </clr-datagrid>
              </div>
            </clr-tab-content>
          </ng-template>
        </clr-tab>
        <clr-tab>
          <button clrTabLink (click)="wipeStrategyToFlash()">Received</button>
          <ng-template [(clrIfActive)]="receivedActive">
            <clr-tab-content>
              <div
                class="
                  strategies-container__data-grid__container
                  strategies-container__data-grid__container--received
                "
              >
                <clr-datagrid
                  class="strategies-container__data-grid"
                  [(clrDgSingleSelected)]="selectedReceived"
                >
                  <clr-dg-column *ngFor="let column of receivedColumns">
                    {{ column.displayName }}
                  </clr-dg-column>

                  <clr-dg-row
                    *clrDgItems="
                      let receivedStrat of receivedStrategies$ | async
                    "
                    [clrDgItem]="receivedStrat"
                  >
                    <clr-dg-cell
                      *ngFor="let column of receivedColumns"
                      [ngClass]="
                        column.dbName === 'message' ? 'center-col' : ''
                      "
                      [@.disabled]="
                        receivedStrategyToFlash?.timestamp !==
                          receivedStrat.timestamp ||
                        receivedStrategyToFlash?.shared !== receivedStrat.shared
                      "
                    >
                      <ng-container *ngIf="column.dbName === 'name'">
                        <span [@flashText]="receivedStrategyToFlash">
                          {{ receivedStrat[column.dbName] }}
                        </span>
                      </ng-container>
                      <ng-container *ngIf="column.dbName === 'shared'">
                        <span [@flashText]="receivedStrategyToFlash">
                          {{ getUserEmail(receivedStrat[column.dbName]) }}
                        </span>
                      </ng-container>
                      <ng-container *ngIf="column.dbName === 'timestamp'">
                        <span [@flashText]="receivedStrategyToFlash">
                          {{
                            receivedStrat[column.dbName]
                              | date: 'MMM d y h:mm:ss a'
                          }}
                        </span>
                      </ng-container>
                      <ng-container *ngIf="column.dbName === 'message'">
                        <a
                          [@flashText]="receivedStrategyToFlash"
                          *ngIf="receivedStrat[column.dbName]"
                          role="tooltip"
                          aria-haspopup="true"
                          class="tooltip tooltip-md tooltip-left"
                        >
                          <img src="assets/messages.svg" />
                          <span class="tooltip-content"
                            >{{ receivedStrat[column.dbName] }}
                          </span>
                        </a>
                      </ng-container>
                    </clr-dg-cell>
                  </clr-dg-row>
                  <clr-dg-footer>
                    <div
                      class="strategies-container__data-grid--footer"
                      *ngIf="receivedStrategies$ | async as strategies"
                    >
                      {{
                        strategies?.length || 0
                          | i18nPlural
                            : {
                                '=0': 'No received strategies',
                                '=1': 'One received strategy',
                                other: '# received strategies'
                              }
                      }}
                      <div class="footer-buttons">
                        <ng-container
                          *ngTemplateOutlet="strategyLoadButtonTmpl"
                        ></ng-container>
                        <ng-container
                          *ngTemplateOutlet="strategyDeleteButtonTmpl"
                        ></ng-container>
                      </div>
                    </div>
                  </clr-dg-footer>
                </clr-datagrid>
              </div>
            </clr-tab-content>
          </ng-template>
        </clr-tab>
      </clr-tabs>
    </div>
  </div>
</div>

<ng-template #strategyLoadButtonTmpl>
  <div class="footer-buttons">
    <button
      class="ui-button ui-button__footer"
      (click)="loadStrategyClick()"
      [disabled]="!getActiveTabSelectedItem()"
    >
      Load
    </button>
  </div>
</ng-template>

<ng-template #strategyDeleteButtonTmpl>
  <button
    type="button"
    class="ui-button ui-button__footer"
    (click)="deleteStrategyClick()"
    [disabled]="!getActiveTabSelectedItem()"
  >
    Delete
  </button>
</ng-template>
